export enum AppFeature {
  LEASES = 'LEASES',
}
